import { LuTriangleAlert } from 'react-icons/lu';

import InfoTooltip from '@components/infoTooltip/InfoTooltip';

const EstimateWarning = () => {
	return (
		<span className="text-warning">
			<InfoTooltip
				tooltipContainerId="tooltip-sidebar-root"
				placement="top"
				data-tooltip-html="
					<div style='max-width: 200px;'>
						Footprint may be inaccurate. <br/>Use Laser Range Finder (LRF) <br/>for better accuracy.
					</div>
				"
				showIcon={false}>
				<LuTriangleAlert />
			</InfoTooltip>
		</span>
	);
};
export default EstimateWarning;
